import React from 'react';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import useDataLoader2 from '../../hooks/useDataLoader2';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import { formatTimeSpanToString } from '../../utils/functions';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const ContentTag: React.FC = ({ ...props }) => {
  const fields = ['id', 'name', 'createdDate']
  const endpoint = '/contentTag';

  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });
  
  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: 'Name' },
    { id: 'createdDate', header: 'Created Date' },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const formatData = (data: any) => {
    return data.map((item: any) => {    
      return {
        ...item,
        createdDate: formatTimeSpanToString(item.createdDate),
      };
    });
  };

  const filtersData: IFilterData[] = [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
  ]

  return (
    <div>
      <CatalogTableC
        title={`Content Tag Catalog`}
        catalogName={'TAGS'}
        route={'PublicationTag'}
        catalogShortName={'TAG'}
        totalCount={totalCount}
      >
        <Filters
          filtersData={filtersData} 
          filterValues={inputFilters}
          setFilterValues={setInputFilters} 
          Search={() => fetchData()}
          clearSelections={() => fetchData(true)}
          setValueForQuery={setFilter}
        />
        <PaginatedTable
          data={data || []}
          columnsDef={columnsDef}
          formatData={formatData}
          sorting={sort}
          onSortingChange={setSort}
          totalCount={totalCount || 0}
          pagination={pagination}
          onPaginationChange={setPagination}
          endpoint={endpoint}
          onExportAll={() =>
            exportAllDataLoader2<any>({
              endpoint,
              filter,
              sort,
              pageSize: 1000,
              fields,
            })
          }
        />
      </CatalogTableC>
    </div>
  );
};

export default ContentTag;
